import { combineReducers } from "redux-immutable";

import CoursesStateSlice from "../../models/state/CoursesStateSlice";
import contents from "./contents";
import courses from "./courses";
import meta from "./meta";
import modules from "./modules";
import sections from "./sections";
import words from "./words";

export default combineReducers(
  {
    courses,
    sections,
    contents,
    modules,
    meta,
    words
  },
  () => new CoursesStateSlice() as any
);
